import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiBalanceTskSwapUsdt, ApiBalanceUsdtSwapTsk } from "@/api";
import type { BalanceSwapRequest, BalanceSwapResponse } from "@/api/types";
import { showError } from "@/lib/toast";
import { useTranslation } from "react-i18next";

export function useBalanceUsdtSwapTsk() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async (
      data: BalanceSwapRequest
    ): Promise<BalanceSwapResponse> => {
      console.log("ApiBalanceUsdtSwapTsk", data);
      const res = await ApiBalanceUsdtSwapTsk(data);
      console.log("ApiBalanceUsdtSwapTsk", res);
      return res.data;
    },
    onSuccess: (res: BalanceSwapResponse) => {
      queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
      if (res.resultCode !== 0) {
        showError(
          t(mapBalanceSwapResultCodeToI18nKey(Number(res.resultCode)), {
            defaultValue: res.resultMsg || t("toast.swap.failed"),
          })
        );
      }
    },
  });
}

export function useBalanceTskSwapUsdt() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async (
      data: BalanceSwapRequest
    ): Promise<BalanceSwapResponse> => {
      const res = await ApiBalanceTskSwapUsdt(data);
      return res.data;
    },
    onSuccess: (res: BalanceSwapResponse) => {
      queryClient.invalidateQueries({ queryKey: ["balanceV2"] });
      if (res.resultCode !== 0) {
        showError(
          t(mapBalanceSwapResultCodeToI18nKey(Number(res.resultCode)), {
            defaultValue: res.resultMsg || t("toast.swap.failed"),
          })
        );
      }
    },
  });
}

export function mapBalanceSwapResultCodeToI18nKey(resultCode: number): string {
  switch (resultCode) {
    case 0:
      return "toast.swap.resultCode0";
    case 1:
      return "toast.swap.resultCode1";
    case 2:
      return "toast.swap.resultCode2";
    case 3:
      return "toast.swap.resultCode3";
    case 4:
      return "toast.swap.resultCode4";
    case 5:
      return "toast.swap.resultCode5";
    case 6:
      return "toast.swap.resultCode6";
    case 7:
      return "toast.swap.resultCode7";
    case 888:
      return "toast.swap.resultCode888";
    case 999:
      return "toast.swap.resultCode999";
    default:
      return "toast.swap.failed";
  }
}
